export default function getPrecisedNumber(value = 0, precision = 12): string {
  const parts = (+value).toFixed(precision).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  parts[1] =
    parseInt(parts[1], 10) > 0 ? parts[1].replace(/([^0]*)0*$/g, '$1') : '00';
  parts[1] = parts[1].length < 2 ? `${parts[1]}0` : parts[1];
  return parts.join('.');
}
